import { useState } from "react";

import { useSubscription } from "@apollo/client/react";
import { Modal } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";

import { userFeatureEnabled } from "@/abilities/helpers";
import TTModal from "@/components/TTModal";
import { DoneButton } from "@/containers/buttons";
import { NotifyRosterHourDocument, type NotifyRosterHourSubscription } from "@/gql/graphql";
import { useAppSelector } from "@/hooks";
import { sessionSelector } from "@/store/sessionReducer";
import { relativeTime } from "@/utils/dates";

export default function TaskNotificationModal() {
  const { currentUser } = useAppSelector(sessionSelector);
  const [showModal, setShowModal] = useState(false);
  const [hour, setHour] = useState<Nilable<NotifyRosterHourSubscription["notifyRosterHour"]>>(null);
  const { t } = useTranslation(["roster"]);

  useSubscription(NotifyRosterHourDocument, {
    skip: !userFeatureEnabled(currentUser, "roster"),
    onData: ({ data: { data } }) => {
      if (!data) return;

      if (localStorage.getItem("lastRosterHourNotification") !== data.notifyRosterHour.id) {
        setHour(data.notifyRosterHour);
        setShowModal(true);
      }
    },
  });

  function closeModal() {
    setShowModal(false);
    localStorage.setItem("lastRosterHourNotification", hour!.id);
  }

  if (!hour) return null;

  return (
    <TTModal show={showModal} onHide={() => setShowModal(false)} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t("roster:notification_modal.title")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Trans t={t} i18nKey="roster:notification_modal.body">
          Aufgabe „{{ taskName: hour.task.name }}“ beginnt {{ time: relativeTime(hour.hour) }}
        </Trans>
      </Modal.Body>

      <Modal.Footer>
        <DoneButton onClick={closeModal}>{t("roster:notification_modal.understood")}</DoneButton>
      </Modal.Footer>
    </TTModal>
  );
}
